module.exports = __webpack_public_path__ + "static/media/Unblock.1bd45b4f.svg";